import React, { useState } from "react";
import styled from "styled-components";
function Right_bar()
{
    const [reqested,setrequested]=useState(false);
    const hadleRequest=()=>{
        setrequested(!reqested);
    }
    return(
        <Con>
        </Con>
    );
}

export default Right_bar;

const Con=styled.div`
@media(max-width:1000px)
{
    display:none;
}
`;